import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import CustomLink from '@bitComponents/unifiedComponents/CustomLink';
import { whichAnimationEvent } from '@bitComponents/utils/styleUtils';
import { MODAL_CONTENT } from '@bitComponents/utils/tagging';
import { sendCMSEvent } from '@bitComponents/utils/metrics';
import './Modal.scss';

let modalRoot = null;

const COMPONENT_NAME = 'Modal';

export const OPACITY_LAYOUT_COLORS = {
  BLACK: 'black',
  WHITE: 'white',
  BLACK05: 'black05',
  TRANSPARENT: 'transparent',
}
// XPOSITION_ YPOSITION
export const CONTENT_POSITION = {
  // absolutelly center
  CENTER_CENTER: 'center--center',
  LEFT_CENTER: 'left--center',
  RIGHT_CENTER: 'right--center',
  // vertically top
  CENTER_TOP: 'center--top',
  RIGHT_TOP: 'right--top',
  LEFT_TOP: 'left--top',
  // vertically bottom
  CENTER_BOTTOM: 'center--bottom',
  RIGHT_BOTTOM: 'right--bottom',
  LEFT_BOTTOM: 'left--bottom',
  CUSTOM: 'custom',
}

export const IN_SCENE_EFFECT = {
  FADE_IN: 'fadeIn',
  FADE_IN_LEFT: 'fadeInLeft',
  FADE_IN_RIGHT: 'fadeInRight',
  FADE_IN_TOP: 'fadeInTop',
  FADE_IN_BOTTOM: 'fadeInBottom',
}

export const OUT_SCENE_EFFECT = {
  FADE_OUT: 'fadeOut',
  FADE_OUT_LEFT: 'fadeOutLeft',
  FADE_OUT_RIGHT: 'fadeOutRight',
  FADE_OUT_TOP: 'fadeOutTop',
  FADE_OUT_BOTTOM: 'fadeOutBottom',
}


class SgnModal extends Component {

  static show() { SgnModal.__singletonRef.__show(); }

  static hide() { SgnModal.__singletonRef.__hide(); }

  static setContent(component) { SgnModal.__singletonRef.__setContent(component); }

  static setModalProps(props) { SgnModal.__singletonRef.__setModalProps(props); }

  constructor(props) {
    super(props);
    const { projectId } = props;
    if (projectId) {
      const appDiv = document.getElementById(projectId);
      if (appDiv) {
        modalRoot = appDiv.getElementsByClassName('modal-root');
        if (modalRoot && modalRoot.length > 0) {
          modalRoot = modalRoot[0];
        } else {
          modalRoot = document.getElementById('modal-root');
        }
      }
    } else {
      modalRoot = document.getElementById('modal-root');
    }
    // TEngo que encontrar mi hueco
    const {
      opacityLayoutColor,
      contentPosition,
      className,
      inSceneEffect,
      outSceneEffect,
      closeByClickingOutside,
      taggingInfoWhenClickingOutside,
      taggingInfo,
      contentInsideContainer,
      scrollAllowed,
      onCloseHandler,
    } = props;

    SgnModal.__singletonRef = this;

    this.state = {
      unMounted: true,
      show: false,
      className,
      inSceneEffect,
      outSceneEffect,
      contentPosition,
      opacityLayoutColor,
      closeByClickingOutside,
      taggingInfoWhenClickingOutside,
      taggingInfo,
      contentInsideContainer,
      scrollAllowed,
      onCloseHandler,
    }
  }

  /* this handle transition and unmounted event */
  componentDidUpdate = () => {
    const { show, unMounted } = this.state;
    if (!show && !unMounted) {
      const transitionEvent = whichAnimationEvent();
      const element = document.getElementById('animationReference');
      if (transitionEvent) {
        element.addEventListener(transitionEvent, (animationEvent) => {
          if(animationEvent?.animationName === "modalFadeOut"){
            // hide modal root
            modalRoot.classList.remove('visible');
            this.setState({ unMounted: true })
          }
        });
      }
    }
  }

  createContentCss = (contentPosition, inSceneEffect, outSceneEffect, show, className) => {
    const arrayContentPosition = contentPosition && contentPosition.split('--');
    const isCustom =
      Array.isArray(arrayContentPosition) &&
      arrayContentPosition.length > 0 &&
      arrayContentPosition[0] === CONTENT_POSITION.CUSTOM;
    let cssContentPosition = '';
    let customPosition = {};
    let currentContentPosition = contentPosition;
    if (isCustom) {
      cssContentPosition = 'Modal_content Modal_content--custom';
      currentContentPosition = 'custom';
      if (arrayContentPosition.length > 3) {
        const positionX = arrayContentPosition[1];
        const positionY = arrayContentPosition[2];
        const currentTransform = arrayContentPosition[3];
        customPosition = { top: `${positionY}`, left: `${positionX}`, transform: currentTransform };
      }

    } else {
      cssContentPosition = contentPosition ? `Modal_content Modal_content--${contentPosition}` : '';
    }
    let sceneCss = inSceneEffect ? ` Modal_content--${currentContentPosition}--${inSceneEffect}` : '';
    if (!show) {
      sceneCss = outSceneEffect ? ` Modal_content--${currentContentPosition}--${outSceneEffect}` : '';
    }
    const cssOwnClassName = className ? ` ${className}` : '';
    return {
      contentCss: `${cssContentPosition}${sceneCss}${cssOwnClassName}`,
      customPosition,
    }
  }

  createOpacityLayoutCss = (opacityLayoutColor, show) => {
    let cssOpacityLayout = `Single_Modal opacity_layout opacity_layout--${opacityLayoutColor} Single_Modal--fadeIn`;
    if (!show) {
      cssOpacityLayout = `Single_Modal opacity_layout opacity_layout--${opacityLayoutColor} Single_Modal--fadeOut`;
    }
    return cssOpacityLayout;
  }

  handleCloseOnLayout = () => {
    const { closeByClickingOutside, onCloseHandler } = this.state;
    if (closeByClickingOutside) {
      const myInstance = this.constructor;
      myInstance.hide();
      if(onCloseHandler){
        onCloseHandler();
      }
    }
  }

  setScrollOnElements = (scrollValue) => {
    const body = document.getElementsByTagName('body')[0];
    const html = document.getElementsByTagName('html')[0];
    body.style.overflowY = scrollValue;
    html.style.overflowY = scrollValue;
  }

  __setContent(content) { this.setState({ content }) }

  __setModalProps(props) {
    const { scrollAllowed, show } = props;
    if (scrollAllowed) {
      this.setScrollOnElements('auto');
    }
    if (typeof show !== 'undefined' && show) {
      this.__show();
    }
    if (typeof show !== 'undefined' && !show) {
      this.__hide();
    }

    this.setState({ ...props });
  }

  __show() {
    const { scrollAllowed } = this.state;
    // show modal-root
    modalRoot.classList.add('visible');
    // disallow scroll on html,body
    if (!scrollAllowed) {
      this.setScrollOnElements('hidden');
    } else {
      this.setScrollOnElements('auto');
    }
    // set properties
    this.setState({ show: true, unMounted: false })
  }

  __hide() {
    // disallow scroll on html,body
    this.setScrollOnElements('auto');
    this.setState({ show: false });
  }

  handleSendShowModalTaggingInfo = (taggingInfo) => {
    const taggingInfoCompleted = {
      eventType: 'print-success',
      ...taggingInfo,
    };
    if (!taggingInfoCompleted.componentName) {
      taggingInfoCompleted.componentName = COMPONENT_NAME;
    }
    if (!taggingInfoCompleted.componentContent) {
      taggingInfoCompleted.componentContent = MODAL_CONTENT.DEFAULT;
    }
    sendCMSEvent(taggingInfoCompleted);
  }

  renderModalContent = (contentInsideContainer, content, contentCss, customPosition) => {
    if (contentInsideContainer) {
      return (
        <div className="xux">
          <div className="container">
            <div className={`${contentCss}`} style={customPosition}>
              {content}
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className={`${contentCss}`} style={customPosition}>
        {content}
      </div>
    );
  }

  render() {
    const {
      opacityLayoutColor,
      contentPosition,
      className,
      inSceneEffect,
      outSceneEffect,
      unMounted,
      contentInsideContainer,
      taggingInfoWhenClickingOutside,
      taggingInfo,
    } = this.state;

    const { show, content } = this.state;
    const cssOpaticyLayout = this.createOpacityLayoutCss(opacityLayoutColor, show);
    const { contentCss, customPosition } = this.createContentCss(
      contentPosition,
      inSceneEffect,
      outSceneEffect,
      show,
      className,
    );

    if (show) {
      this.handleSendShowModalTaggingInfo(taggingInfo);
    }

    if ((!show && unMounted) || !content) { return null; }


    return ReactDOM.createPortal(
      <Fragment>
        {this.renderModalContent(contentInsideContainer, content, contentCss, customPosition)}
        {taggingInfoWhenClickingOutside && (
          <CustomLink
            id="animationReference"
            isBlockElement
            className={cssOpaticyLayout}
            onClick={this.handleCloseOnLayout}
            onKeyPress={this.handleCloseOnLayout}
            taggingInfo={taggingInfoWhenClickingOutside}
          />
        )}
        {!taggingInfoWhenClickingOutside && (
          <div
            id="animationReference"
            role="button"
            tabIndex="-1"
            className={cssOpaticyLayout}
            onClick={this.handleCloseOnLayout}
            onKeyPress={this.handleCloseOnLayout}
          />
        )}
      </Fragment>,
      modalRoot,
    )
  }
}

SgnModal.propTypes = {
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */ 
  className: PropTypes.string,
  /**
   * {
   *  "info": "Establece si la modal puede ser cerrada al hacer click fuera de ella",
   *  "kind": "both",
   *  "beautifulName": "Cerrar con click fuera"
   * }
   */
  closeByClickingOutside: PropTypes.bool,
  /**
   * {
   *  "info": "Establece si la modal puede ser cerrada al hacer click fuera de ella",
   *  "kind": "both",
   *  "beautifulName": "Cerrar con click fuera"
   * }
   */
  taggingInfoWhenClickingOutside: PropTypes.object,
  /**
   * {
   *  "info": "Establece el taggeado de la modal",
   *  "kind": "both",
   *  "beautifulName": "Tagging info"
   * }
   */
  taggingInfo: PropTypes.object,
  /**
   * {
   *  "info": "Define la posición que ocupará la modal al ser lanzada",
   *  "kind": "both",
   *  "beautifulName": "Posición"
   * }
   */ 
  contentPosition: PropTypes.oneOf([
    CONTENT_POSITION.CENTER_CENTER,
    CONTENT_POSITION.CENTER_TOP,
    CONTENT_POSITION.RIGHT_TOP,
    CONTENT_POSITION.LEFT_TOP,
    CONTENT_POSITION.CENTER_BOTTOM,
  ]),
  /**
   * {
   *  "info": "Define el color de background de la capa layout que cubre la pantalla bajo la modal",
   *  "kind": "both",
   *  "beautifulName": "Estilos layout"
   * }
   */
  opacityLayoutColor: PropTypes.oneOf([
    OPACITY_LAYOUT_COLORS.BLACK,
    OPACITY_LAYOUT_COLORS.WHITE,
    OPACITY_LAYOUT_COLORS.BLACK05,
    OPACITY_LAYOUT_COLORS.TRANSPARENT,
  ]),
  /**
   * {
   *  "info": "Define el efecto con el que se mostrará la modal al ser lanzada",
   *  "kind": "both",
   *  "beautifulName": "Efecto de apertura"
   * }
   */
  inSceneEffect: PropTypes.oneOf([
    IN_SCENE_EFFECT.FADE_IN,
    IN_SCENE_EFFECT.FADE_IN_LEFT,
    IN_SCENE_EFFECT.FADE_IN_RIGHT,
    IN_SCENE_EFFECT.FADE_IN_TOP,
    IN_SCENE_EFFECT.FADE_IN_BOTTOM,
  ]),
  /**
   * {
   *  "info": "Define el efecto con el que se ocultará la modal al ser cerrada",
   *  "kind": "both",
   *  "beautifulName": "Efecto de cierre"
   * }
   */
  outSceneEffect: PropTypes.oneOf([
    OUT_SCENE_EFFECT.FADE_OUT,
    OUT_SCENE_EFFECT.FADE_OUT_LEFT,
    OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
    OUT_SCENE_EFFECT.FADE_OUT_BOTTOM,
    OUT_SCENE_EFFECT.FADE_OUT_TOP,
  ]),
  /**
   * {
   *  "info": "Define si la modal se tiene que mostrar dentro del elemento container de la página o fuera de el",
   *  "kind": "both",
   *  "beautifulName": "Dentro de container"
   * }
   */
  contentInsideContainer: PropTypes.bool,
  /**
   * {
   *  "info": "Define si la modal permite scroll",
   *  "kind": "both",
   *  "beautifulName": "Scrollable"
   * }
   */
  scrollAllowed: PropTypes.bool,
   /**
   * {
   *  "info": "Método que se ejecuta al hacer click fuera del modal",
   *  "kind": "both",
   *  "beautifulName": "Método de cierre"
   * }
   */
  onCloseHandler: PropTypes.func,
}

SgnModal.defaultProps = {
  className: '',
  closeByClickingOutside: false,
  taggingInfo: null,
  taggingInfoWhenClickingOutside: null,
  contentPosition: CONTENT_POSITION.CENTER_BOTTOM,
  opacityLayoutColor: OPACITY_LAYOUT_COLORS.BLACK,
  inSceneEffect: IN_SCENE_EFFECT.FADE_IN,
  outSceneEffect: OUT_SCENE_EFFECT.FADE_OUT,
  contentInsideContainer: false,
  scrollAllowed: false,
  onCloseHandler: null,
}

export default SgnModal;
